export enum TipoAcuerdo {
  '#add49e' = 1,
  '#579b40' = 2,
  '#365e27' = 3,
  '#000000' = 4,
}
